import makeStyles from '@mui/styles/makeStyles';

const styles = (isOnViewMode: boolean) =>
  makeStyles(() => ({
    container: {
      position: "relative",
      minHeight: isOnViewMode ? "" : "calc(100vh - 300px)",
      paddingBottom: "40px",
    },
    buttons: {
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    addressComponentMargin: {
      marginTop: "15px",
    },
  }));

export default styles;
